"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("antd/lib/row/style");
var _row = _interopRequireDefault(require("antd/lib/row"));
require("antd/lib/col/style");
var _col = _interopRequireDefault(require("antd/lib/col"));
var _classnames = _interopRequireDefault(require("classnames"));
var _opentokReact = require("opentok-react");
var _react = _interopRequireWildcard(require("react"));
var _utils = require("../../../utils");
var _ = require("../..");
var _components = require("../../../components");
var _constants = require("../constants");
var _Video = require("./Video");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var Publisher = function Publisher(_ref) {
  var addReconnectionAttempt = _ref.addReconnectionAttempt,
    audioEnabled = _ref.audioEnabled,
    devices = _ref.devices,
    onConnect = _ref.onConnect,
    _onError = _ref.onError,
    updateMessage = _ref.updateMessage,
    userAvatarImage = _ref.userAvatarImage,
    userAvatarName = _ref.userAvatarName,
    videoEnabled = _ref.videoEnabled,
    toggleScreenSharingEnabled = _ref.toggleScreenSharingEnabled,
    toggleIsScreenShareOn = _ref.toggleIsScreenShareOn,
    isScreenShareOn = _ref.isScreenShareOn;
  var _useAuth = (0, _.useAuth)(),
    user = _useAuth.user;
  var _useState = (0, _react.useState)(null),
    _useState2 = _slicedToArray(_useState, 2),
    publisher = _useState2[0],
    setPublisher = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    orientationPortrait = _useState4[0],
    setOrientationPortrait = _useState4[1];
  var _useVideoChat = (0, _.useVideoChat)(),
    isSubscribed = _useVideoChat.isSubscribed;
  var publisherEventHandlers = {
    accessDenied: function accessDenied(e) {
      try {
        if (_Video.VIDEO_LOGGING_VERBOSE) {
          console.error('accessDenied', e);
        }
      } catch (err) {
        console.error(err);
      }
    },
    accessDialogOpened: function () {
      var _accessDialogOpened = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(e) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                e.preventDefault();
                if (!e.target.accessAllowed) {
                  // TODO: Review design for this state
                  // const title = 'Please click the Allow button to start your video session';
                  // toast.info({ title });
                }
                if (_Video.VIDEO_LOGGING_VERBOSE) {
                  console.error("accessDialogOpened ".concat(e));
                }
              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      function accessDialogOpened(_x) {
        return _accessDialogOpened.apply(this, arguments);
      }
      return accessDialogOpened;
    }(),
    accessDialogClosed: function accessDialogClosed() {},
    streamCreated: function streamCreated(event) {
      if (!publisher) {
        var _event$stream, _event$stream$connect;
        onConnect(event === null || event === void 0 ? void 0 : (_event$stream = event.stream) === null || _event$stream === void 0 ? void 0 : (_event$stream$connect = _event$stream.connection) === null || _event$stream$connect === void 0 ? void 0 : _event$stream$connect.connectionId);
      }
      setPublisher(event.target);
    },
    streamDestroyed: function streamDestroyed(event) {
      if (event.reason === 'networkDisconnected') {
        updateMessage(_constants.MESSAGES.PUBLISHER_DISCONNECTED());
        addReconnectionAttempt();
      }
      if (_Video.VIDEO_LOGGING_VERBOSE) {
        console.error('streamDestroyed', event);
      }
    },
    videoDimensionsChanged: function videoDimensionsChanged(e) {
      var _ref2 = e.newValue || {},
        height = _ref2.height,
        width = _ref2.width;
      var isPortrait = height / width > 1;
      setOrientationPortrait(isPortrait);
    }
  };
  var publisherScreenEventHandlers = {
    accessDenied: function accessDenied(e) {
      try {
        if (_Video.VIDEO_LOGGING_VERBOSE) {
          console.error('Screen Share accessDenied', e);
        }
      } catch (err) {
        console.error(err);
      }
    },
    mediaStopped: toggleScreenSharingEnabled,
    streamCreated: toggleScreenSharingEnabled
  };
  var resolution = (0, _utils.isMobile)() ? '320x240' : '640x480';
  var frameRate = (0, _utils.isMobile)() ? 15 : 30;
  return /*#__PURE__*/_react.default.createElement(_row.default, {
    type: "flex",
    justify: "center",
    align: "middle",
    className: (0, _classnames.default)('video-publisher-container', orientationPortrait && 'video-publisher-portrait', !videoEnabled && 'publisher-hidden')
  }, /*#__PURE__*/_react.default.createElement(_col.default, {
    span: 24,
    className: "publisher"
  }, /*#__PURE__*/_react.default.createElement(_opentokReact.OTPublisher, {
    properties: {
      showControls: false,
      publishAudio: audioEnabled,
      publishVideo: videoEnabled,
      height: '100%',
      width: '100%',
      resolution: resolution,
      audioSource: devices === null || devices === void 0 ? void 0 : devices.audio,
      videoSource: devices === null || devices === void 0 ? void 0 : devices.video,
      frameRate: frameRate,
      name: user.nickName
    },
    onError: _onError,
    eventHandlers: publisherEventHandlers
  }), isScreenShareOn && /*#__PURE__*/_react.default.createElement("div", {
    className: "screen-sharing-publisher"
  }, /*#__PURE__*/_react.default.createElement(_opentokReact.OTPublisher, {
    properties: {
      showControls: false,
      height: '100%',
      width: '100%',
      videoSource: 'screen'
    },
    onError: function onError(error) {
      if (error.name === 'OT_USER_MEDIA_ACCESS_DENIED') {
        toggleIsScreenShareOn();
      } else {
        _onError(error);
      }
    },
    eventHandlers: publisherScreenEventHandlers
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('publisher-placeholder', !videoEnabled ? 'flex' : 'none',
    // Other person has joined the call -> placeholder is in the top right corner
    // Other person has not joined the called -> placeholder is in the center
    isSubscribed ? 'justify-end mt-[10px]' : 'justify-center')
  }, /*#__PURE__*/_react.default.createElement(_components.Avatar, {
    size: isSubscribed ? 50 : 82,
    imageId: userAvatarImage,
    name: userAvatarName,
    shape: "circle",
    className: "rounded-full overflow-auto",
    isCdnImage: !!userAvatarImage
  }))));
};
var _default = Publisher;
exports.default = _default;